import * as _ from 'lodash';

// Shared by the Edit Packages dialog and the inline packages editor in service details.
// `packageSizes` is the order settings `itemSizeList`.

export function createNewPackageItem(packageSizes: any[], defaultItemSize: string) {
  const defaultItem = _.find(packageSizes, (p) => {
    return p.itemSize === defaultItemSize;
  });

  return {
    count: 1,
    barcode: null,
    value: _.get(defaultItem, 'value'),
    size: _.get(defaultItem, 'itemSize'),
    type: _.get(defaultItem, 'itemSize'),
    labels: _.get(defaultItem, 'labels', []),
    dimensions: _.cloneDeep(_.get(defaultItem, 'dimensions', {})),
    weight: _.get(defaultItem, 'weight'),
  };
}

// package-list-update emits the changed item with its size under `type`; items are persisted with `size`.
export function replacePackageItem(items: any[], packageItem: any, index: number): any[] {
  _.set(packageItem, 'size', packageItem.type);
  _.unset(packageItem, 'type');

  const itemsCopy = _.cloneDeep(items);
  itemsCopy[index] = packageItem;
  return itemsCopy;
}
